import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  num: 1,
  title: 'Guía para Vender por Instagram',
  desc: 'Tips comprobados para atraer clientas y vender ropa para mascotas online.',
  price: '5.000'
}, {
  num: 2,
  title: 'Pack de Diseños Exclusivos',
  desc: 'Plantillas premium de outfits exclusivos que no están en los tomos.',
  price: '5.000'
}, {
  num: 3,
  title: 'Lista de Materiales y Proveedores',
  desc: 'Todo lo que necesitás para arrancar fácil desde casa.',
  price: '5.000'
}];
export function Bonuses() {
  return <section id="bonos" className="py-24 bg-white relative" data-id="element-24">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-25">
        <div className="text-center mb-12" data-id="element-26">
          <div className="inline-flex items-center justify-center p-4 bg-brand-pink-light rounded-full mb-4" data-id="element-27">
            <Gift size={32} className="text-brand-rose" data-id="element-28" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-29">
            <span className="text-brand-rose" data-id="element-30">3 Bonos exclusivos</span> por
            tiempo limitado
          </h2>
          <p className="text-lg text-brand-brown/80 mb-6" data-id="element-31">
            Llevate estos regalos increíbles hoy mismo con tu compra.
          </p>

          {/* Eye-catching callout */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-3 bg-gradient-to-r from-brand-pink-light via-white to-brand-pink-light px-6 py-3 rounded-full shadow-soft-pink border border-brand-pink-mid" data-id="element-32">
            <span className="text-xl" data-id="element-33">🎁</span>
            <span className="font-medium text-brand-brown text-base md:text-lg" data-id="element-34">
              Te lo llevás{' '}
              <span className="font-bold text-brand-rose text-xl md:text-2xl" data-id="element-35">
                GRATIS
              </span>{' '}
              por hoy
            </span>
            <span className="text-xl" data-id="element-36">🎁</span>
          </motion.div>
        </div>

        <div className="space-y-6" data-id="element-37">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative bg-brand-cream-light rounded-3xl p-6 md:p-8 flex flex-col md:flex-row items-start md:items-center gap-6 overflow-hidden group" data-id="element-38">
              <div className="absolute inset-0 border-2 border-brand-pink-mid rounded-3xl opacity-50" data-id="element-39"></div>
              <motion.div className="absolute inset-0 border-2 border-brand-rose rounded-3xl" animate={{
            opacity: [0, 1, 0]
          }} transition={{
            duration: 2,
            repeat: Infinity,
            delay: index * 0.5
          }} data-id="element-40"></motion.div>

              <div className="absolute top-0 right-0 bg-brand-rose text-white text-xs font-bold px-4 py-1 rounded-bl-xl z-10" data-id="element-41">
                REGALO
              </div>

              <div className="w-16 h-16 shrink-0 bg-white rounded-2xl flex items-center justify-center shadow-sm text-brand-rose font-serif text-2xl font-bold" data-id="element-42">
                #{bonus.num}
              </div>

              <div className="flex-1" data-id="element-43">
                <h3 className="text-xl md:text-2xl font-bold mb-2" data-id="element-44">
                  BONO #{bonus.num} — {bonus.title}
                </h3>
                <p className="text-brand-brown/80" data-id="element-45">{bonus.desc}</p>
              </div>

              {/* Price - crossed out + GRATIS */}
              <div className="flex md:flex-col items-center md:items-end gap-2 md:gap-1 shrink-0 relative z-10" data-id="element-46">
                <span className="text-brand-brown/50 line-through text-base md:text-lg font-semibold" data-id="element-47">
                  ${bonus.price}
                </span>
                <span className="inline-block bg-brand-rose text-white font-bold text-sm px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-48">
                  Gratis hoy
                </span>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 text-center bg-brand-pink-light/30 p-8 rounded-3xl border border-brand-pink-light" data-id="element-49">
          <p className="text-lg text-brand-brown/70 mb-2" data-id="element-50">
            Valor total de los bonos:{' '}
            <span className="line-through" data-id="element-51">$15.000</span>
          </p>
          <p className="text-2xl md:text-3xl font-bold text-brand-rose" data-id="element-52">
            HOY: ¡GRATIS con tu KIT! 💕
          </p>
        </motion.div>
      </div>
    </section>;
}